export enum Provider {
  SSO = 'sso',
}
